/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from 'app/core/security/login/login.component';
import { AppAuthGuardService } from 'app/core/security/guards/app-auth-guard.service';
import { PageNotFoundComponent } from 'app/core/app-routes/page-not-found/page-not-found.component';
import { PrintLayoutComponent } from 'app/print/print-layout.component';
import { ToBeImplementedComponent } from 'app/shared/components/to-be-implemented/to-be-implemented.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  // {
  //   path: 'print-it',
  //   outlet: 'print-out',
  //   component: PrintLayoutComponent,
  //   children: [
  //     { path: 'zest', component: ToBeImplementedComponent },
  //   ]
  // },
  {
    path: 'print-it',
    outlet: 'print-out',
    component: PrintLayoutComponent,
    children: [
      { path: 'zest', component: ToBeImplementedComponent },
    ]
},
  {
    path: '**',
    canActivate: [AppAuthGuardService],
    component: PageNotFoundComponent
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  declarations: [
    PageNotFoundComponent
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutesModule { }
